import { NgModule } from '@angular/core';

import { MasterConsultaFundosActions } from './master-consulta-fundos.actions';

@NgModule({
  providers: [
    MasterConsultaFundosActions
  ]
})
export class MasterConsultaFundosActionsModule {}
